module.exports = __webpack_public_path__ + "img/millfields_rd.d1a58b61.jpg";